import IconBot from './IconBot';

const AutoConnectBot = ({ sendBotMessage, disabled = false }: any) => {
	return <IconBot id="bot" onClick={() => !disabled && sendBotMessage()} />;
};

export default AutoConnectBot;
